import { render, staticRenderFns } from "./CmfPickupStep2.vue?vue&type=template&id=2af672be&scoped=true"
import script from "./CmfPickupStep2.vue?vue&type=script&lang=js"
export * from "./CmfPickupStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af672be",
  null
  
)

export default component.exports